import React from "react";
import { Box, BoxProps } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

export const DialogLoader: React.FC<BoxProps> = ({ ...props }) => (
  <Box data-testid="Dialog__Loader" {...props}>
    <Box width="131px" mb={3}>
      <Skeleton variant="text" component="span" animation="wave" />
    </Box>
    <Box width="531px" mb={3}>
      <Skeleton variant="text" component="span" animation="wave" />
    </Box>
    <Box width="531px" mb={3}>
      <Skeleton variant="text" component="span" animation="wave" />
    </Box>
  </Box>
);
